<template>
  <div class="ja-stream-group-name">
    <common-header>
      <template #header>
        <span>配信グループ名を入力</span>
      </template>
    </common-header>

    <div class="stream-group-name-input-area">
      <label for="streamGroupName">配信グループ名</label>
      <div class="stream-group-name-input-wrapper">
        <input
          type="text"
          class="stream-group-name-input"
          id="streamGroupName"
          placeholder="入力してください"
          v-model="streamGroupName"
          maxlength="50"
        />
        <div class="modal-close-button-area">
          <Button class="modal-close-button" @click="deleteStreamGroupName">
            <v-ons-icon class="modal-close-icon" icon="fa-close" />
          </Button>
        </div>
      </div>
    </div>

    <common-footer class="footer">
      <template #footer>
        <v-ons-row class="footer-button-area">
          <small-button
            class="footer-back-button"
            title="戻る"
            :disabled="false"
            @click="() => moveBackButton(router)"
          />
          <small-button
            class="footer-next-button"
            title="次へ"
            :disabled="isNextButtonDisable"
            @click="moveContentConfirm"
          />
        </v-ons-row>
      </template>
    </common-footer>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { moveBackButton } from '@/composable/common';

import CommonHeader from '@/components/common/CommonHeader.vue';
import CommonFooter from '@/components/common/CommonFooter.vue';
import SmallButton from '@/components/common/SmallButton.vue';
import Button from '@/components/common/Button.vue';

// vuexストアとルーターの取得
const store = useStore();
const router = useRouter();

// 配信グループ名
const streamGroupName = ref('');

onMounted(() => {
  // 配信グループ名がストアに入力されている場合は初期表示
  const storeGroupName = store.getters['streamGroup/getStreamGroupName'];
  if (storeGroupName && storeGroupName.length !== 0) {
    streamGroupName.value = storeGroupName;
  } else {
    // 配信グループ名が空白の場合は"YYYY/MM/DD hh:mm"を出力する
    const nowDate = new Date();
    // 年月日取得
    const today = `${nowDate.getFullYear()}/${`0${nowDate.getMonth() + 1}`.slice(
      -2
    )}/${`0${nowDate.getDate()}`.slice(-2)}`;
    // 時間取得
    const time = ` ${`0${nowDate.getHours()}`.slice(-2)}:${`0${nowDate.getMinutes()}`.slice(-2)}`;
    streamGroupName.value = today + time;
  }
});

// 「次へ」ボタン活性判定処理
const isNextButtonDisable = computed(() => {
  return streamGroupName.value === '';
});

// コンテンツ確認画面遷移処理
const moveContentConfirm = () => {
  store.commit('streamGroup/setStreamGroupName', streamGroupName.value);
  router.push('/ja/streamGroup/streamGroupConfirm');
};

// 入力文字削除処理
const deleteStreamGroupName = () => {
  streamGroupName.value = '';
};
</script>

<style scoped>
.ja-stream-group-name {
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.stream-group-name-input-area {
  margin: auto;
  padding-top: 10vh;
  padding-bottom: 10vh;
  width: 90%;
  height: 3rem;
  max-width: 840px;
}
.stream-group-name-input {
  border: solid 1px #dddddd;
  box-sizing: border-box;
  font-size: 1.8rem;
  height: 5rem;
  padding: 0 4rem 0 1rem;
  width: 100%;
}
label {
  display: none;
}
input::placeholder {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.footer-button-area {
  height: 100%;
  width: 90%;
}
.footer-back-button {
  background: #fff;
  border: solid 1px #cccccc;
  color: #222222;
  margin: auto;
  padding: 1rem 0;
  text-align: center;
  width: 25%;
}
.footer-next-button {
  box-shadow: 0rem 0.2rem #21963b;
  color: #fff;
  margin: auto;
  padding: 1rem 0;
  text-align: center;
  width: 65%;
  cursor: pointer;
}
.footer-next-button:hover {
  opacity: 0.8;
}
.stream-group-name-input-wrapper {
  position: relative;
}
.modal-close-button-area {
  position: absolute;
  right: 1.5rem;
  top: 50%;
  transform: translate(0, -50%);
}
.modal-close-button {
  align-items: center;
  background-color: white;
  display: flex;
  height: 100%;
  padding: 0;
  z-index: 1;
}
.modal-close-icon {
  font-size: 2rem;
  margin: auto;
  color: rgba(34, 34, 34, 0.7);
}
.footer {
  height: 9rem;
  flex-direction: column;
}
</style>
